/* eslint-disable react-hooks/exhaustive-deps */
import { Alert } from '@mui/material'
import MatAppBar from '../MatAppBar/MatAppBar'
import { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { makeStyles, createStyles } from '@mui/styles'
import { setShouldRender } from '../ProgressOverlay/store/actionCreator'
import CacheListManager from '../CacheListManager/CacheListManager'
import {
  api,
  INPUT_PERFORMANCE_DELAY,
  SCHEDULE_OR_ASSIGNMENT,
  WORK_ORDER_FILTER_PROPERTIES,
} from '../../globalConstants'
import { fetchData } from '../../service/HttpService'
import { setActionNeededWorkorderList } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import { setAssignments } from '../WorkOrderList/WorkOrderListStore/actionCreator'
import { useAuth } from '@praxis/component-auth'
import StatusAlert from '../StatusAlert/StatusAlert'
import CommonCardList from '../CommonCardList/CommonCardList'
import { filterAssignmentsBy7Days } from '../../utils'
import useSearch from '../../utils/hooks/useSearch'

const useStyles = makeStyles((theme) =>
  createStyles({
    cardHeader: {
      background: theme.palette.grey[300],
    },
    actionIcon: {
      margin: theme.spacing(1, 0.5, 0, 0),
    },
    cardContent: {
      padding: theme.spacing(1),
    },
    warningError: {
      margin: theme.spacing(1),
    },
  }),
)

const ActionNeededWorkOrders = ({
  actionNeededWorkorders,
  setShouldRender,
  lastUpdated,
  storeId,
  setActionNeededWorkorderList,
  setAssignments,
  toggle,
}) => {
  const URL_SEARCH_KEY = 'search'
  const classes = useStyles()
  const auth = useAuth()
  const userId = auth.session.userInfo.lanId?.toUpperCase()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const { isDCUser } = useSelector((state) => ({
    ...state.userInfoReducer,
  }))

  const [filteredWorkOrders, onSearch] = useSearch(
    URL_SEARCH_KEY,
    actionNeededWorkorders || [],
    WORK_ORDER_FILTER_PROPERTIES(isDCUser),
    true,
    INPUT_PERFORMANCE_DELAY,
  )

  const actionNeededWorkordersLength = actionNeededWorkorders?.length

  useEffect(() => {
    const getOpenWorkOrders = async () => {
      if (!actionNeededWorkordersLength && !loading) {
        try {
          setShouldRender(true, 'Loading...', 'Action Needed Work Orders')
          setLoading(true)
          setError(false)
          const response = await fetchData(api.openWorkOrders(storeId))
          setActionNeededWorkorderList(response.woDetails)
        } catch (error) {
          setError(true)
        } finally {
          setLoading(false)
          setShouldRender(false)
        }
      }
    }
    getOpenWorkOrders()
  }, [actionNeededWorkordersLength])

  const infoMessage = `${filteredWorkOrders?.length} / ${actionNeededWorkordersLength} Internal Work Order(s)`

  const getAssignments = async () => {
    try {
      setShouldRender(true, 'Loading...', SCHEDULE_OR_ASSIGNMENT(isDCUser))
      const response = await fetchData(api.myAssignments(storeId, userId))
      const assigmentsScheduledThisWeek = filterAssignmentsBy7Days(
        response.assignmentsdata,
      )
      setAssignments(assigmentsScheduledThisWeek)
    } catch (error) {
      setError(true)
    } finally {
      setLoading(false)
      setShouldRender(false)
    }
  }

  useEffect(() => {
    actionNeededWorkordersLength && getAssignments()
  }, [toggle, actionNeededWorkordersLength])

  return (
    <>
      <MatAppBar
        arrowBack
        text="Action Needed WOs"
        search={{
          onSearch: (input) => onSearch(input),
          searchKey: URL_SEARCH_KEY,
        }}
      />
      {actionNeededWorkordersLength > 0 && !loading && (
        <CacheListManager
          lastUpdated={lastUpdated}
          listLength={actionNeededWorkorders}
          clearMethod={() => setActionNeededWorkorderList([])}
        />
      )}
      {!filteredWorkOrders?.length && !loading && !error && (
        <Alert
          severity="warning"
          data-testid={'no-data-text'}
          className={classes.warningError}
        >
          There are no action needed work orders to display.
        </Alert>
      )}
      {error && !loading && (
        <Alert severity="error" className={classes.warningError}>
          Unable to connect to work orders service.
        </Alert>
      )}

      {filteredWorkOrders && !loading ? (
        <>
          <StatusAlert text={infoMessage} />
          <CommonCardList
            listData={filteredWorkOrders}
            filteredWorkOrdersLength={actionNeededWorkordersLength}
          />
        </>
      ) : null}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    actionNeededWorkorders: state.workOrderListReducer.actionNeededWorkorders,
    storeId: state.storeInfoReducer.storeId,
    lastUpdated: state.workOrderListReducer.lastUpdated.actionNeededWorkorders,
    toggle: state.workOrderListReducer.toggle,
  }
}

const mapDispatchToProps = {
  setShouldRender,
  setActionNeededWorkorderList,
  setAssignments,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ActionNeededWorkOrders)
